import React from "react";

import "../css/publicidadtarjeta.css";
import blog from "../img/blog.jpg"
import redes from "../img/redes.png"

const PublicidadTarjeta = (props) => {
  return (
    <div className="container mt-5">
      <div className="row text-start">
        <div className="col-md-6">
          <a href="#" className="card cardPubli mb-3 shadow">
            <div className="row g-0">
              <div className="col-md-8">
                <div className="card-body">
                  <h3 className="card-title">Instagram @vidonbar</h3>
                  <p className="card-text">
                    Puedes seguirnos por el instagram oficial del bar para no perderte lo ultimo en las redes del bar!
                  </p>
                </div>
              </div>
              <div className="col-md-4 text-center d-none d-sm-block">
                <img src={redes} className="imgPubli" alt="..." />
              </div>
            </div>
          </a>
        </div>

        <div className="col-md-6">
          <a href="#" className="card cardPubli mb-3 shadow">
            <div className="row g-0">
              <div className="col-md-8">
                <div className="card-body">
                  <h3 className="card-title">Blog Vidónero</h3>
                  <p className="card-text">
                    No olvides suscribirte al newsletter de Vidón para no perderte lo ultimo en información referido al bar!
                  </p>
                </div>
              </div>
              <div className="col-md-4 text-center d-none d-sm-block">
                <img src={blog} className="imgPubli" alt="..." />
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicidadTarjeta;
